import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { HeaderButtonBaseProps } from "@/components/Navigation/Buttons/HeaderButton/headerButton.base";

type StoreFinderButtonContextValue = {
    headerButtonProps: HeaderButtonBaseProps;
    store?: CloudStore | null;
};

type StoreFinderButtonContextProviderProps = {
    headerButtonProps: HeaderButtonBaseProps;
    store?: CloudStore | null;
    children: ReactNode;
};

export const StoreFinderButtonContext = createContext<
    StoreFinderButtonContextValue | undefined
>(undefined);

export const StoreFinderButtonContextProvider = ({
    headerButtonProps,
    store,
    children
}: StoreFinderButtonContextProviderProps) => {
    return (
        <StoreFinderButtonContext
            value={{
                headerButtonProps: headerButtonProps,
                store: store
            }}
        >
            {children}
        </StoreFinderButtonContext>
    );
};

export const useStoreFinderButtonContext = () => {
    const context = use<StoreFinderButtonContextValue | undefined>(
        StoreFinderButtonContext
    );

    if (!isDefined(context)) {
        throw new Error(
            `${StoreFinderButtonContext.displayName} is undefined.`
        );
    }

    return context;
};
